<template>
  <div>
    <CModal v-show="isCollectionModalVisible" @close="closeCollectionModal" footer>
      <template v-slot:title>
        <h5>Create Collection</h5>
      </template>
      <template v-slot:body>
        <div class="p-1">
          <div class="form-group">
            <label for="">Collection Method</label>
            <select name="" id="" v-model="collection.collection_method" class=" form-control">
              <option value="">Please Select Method</option>
              <option value="telephone">Telephone</option>
              <option value="sms">SMS</option>
              <option value="email">Email</option>
              <option value="whatsapp">WhatsApp</option>
            </select>
          </div>
          <div class="form-group">
            <label for="">Collection Object</label>
            <select name="" id="" v-model="collection.collection_object" class="form-control">
              <option value="">Please Select Method</option>
              <option value="client">Client</option>
              <option value="contact">Contact</option>
            </select>
          </div>
          <div class="form-group">
            <label for="">Collection Name</label>
            <input type="text" placeholder="Collection Name" class="form-control"
              v-model="collection.collection_object_name" />
          </div>
          <div class="form-group">
            <label for="">Collection Phone Number</label>
            <input type="text" placeholder="Collection Phone" @keypress="isNumber($event)"
              v-model="collection.collection_phone" class="form-control" />
          </div>
          <div class="form-group">
            <label for="">Collection Result</label>
            <select name="" id="" v-model="collection.collection_result" class=" form-control">
              <option value="">Please Select Collection Result</option>
              <option value="promised-to-pay">Promised To Pay</option>
              <option value="not-reachable">Not Reachable</option>
              <option value="not-interested">Not Interested</option>
              <option value="not-answered">Not Answered</option>
              <option value="not-available">Not Available</option>
              <option value="other">Other</option>
            </select>
          </div>
          <div class="form-group">
            <label for="">Collection Details</label>
            <textarea name="" id="" cols="30" placeholder="Collection Details" rows="4"
              v-model="collection.collection_details" class=" form-control" style="resize: none"></textarea>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <button class="btn btn-secondary" @click="closeCollectionModal">
          Close
        </button>
        <button class="btn btn-primary" @click="createCollection" :disabled="!formIsValid || formLoading">
          <span class="custom-loader" v-if="formLoading">
            <loader-icon size="1.5x" class="custom-class"></loader-icon>
            <span style="font-weight: 600; text-transform: initial;">Please wait</span>
          </span>
          <span v-else>Create Collection</span>
        </button>
      </template>
    </CModal>
    <CModal v-show="isReviewModalVisible" @close="closeReviewModal" footer>
      <template v-slot:title>
        <h5>Review Loan Status</h5>
      </template>
      <template v-slot:body>
        <div class="row justify-content-center">
          <div class="col-md-11 form-group">
            <label for="">Review Status</label>
            <select name="" id="" class="form-control" v-model="r_status">
              <option value="" selected disabled>Please Select Review</option>
              <option value="approved">Approved</option>
              <option value="refused-and-reapply">Refused And Reapply</option>
              <option value="refused-and-after-15-days">Refused And Apply After 15 Days</option>
              <option value="refused-and-after-30-days">Refused And Reapply After 30 Days</option>
            </select>
          </div>
          <div class="col-md-11 form-group">
            <label for="">Review Reason</label>
            <textarea name="" id="" cols="30" rows="2" style="resize:none" v-model="r_reason"
              class=" form-control"></textarea>
          </div>
          <div class="col-md-11 form-group">
            <label for="">Review Details</label>
            <textarea name="" id="" cols="30" rows="4" style="resize:none" v-model="r_details"
              class=" form-control"></textarea>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <button class="btn btn-danger" @click.prevent="closeReviewModal">
          Close
        </button>
        <button class="btn btn-primary" :disabled="formLoading ||
          r_details === '' ||
          r_status === '' ||
          r_reason === ''
          " @click.prevent="reviewLoan">
          <span class="custom-loader" v-if="formLoading">
            <loader-icon size="1.5x" class="custom-class"></loader-icon>
            <span style="font-weight: 600; text-transform: initial;">Please wait</span>
          </span>
          <span v-else>Review Loan</span>
        </button>
      </template>
    </CModal>

    <CModal v-show="isDisburseModalVisible" @close="closeDisburseModal" footer>
      <template v-slot:title>
        <h5 class=" fw-bold">Disburse Loan</h5>
      </template>
      <template v-slot:body>
        <div class="row justify-content-center">
          <div class="col-md-11">
            <div class="form-group">
              <label for="payment_method" class="fw-bold text-dark">Payment Method</label>
              <select name="" id="" v-model="disburse.payment_method" class=" form-control">
                <option value="" selected>Please Select Method</option>
                <option value="core-banking">Core Banking</option>
                <option value="paystack">Paystack</option>
                <option value="flutterwave">Flutterwave</option>
              </select>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <button class="btn btn-danger" @click.prevent="closeDisburseModal">
          Close
        </button>
        <button class="btn btn-primary" @click="disburseLoan" :disabled="formLoading || disburse.payment_method === ''">
          <span class="custom-loader" v-if="formLoading">
            <loader-icon size="1.5x" class="custom-class"></loader-icon>
            <span style="font-weight: 600; text-transform: initial;">Please wait</span>
          </span>
          <span v-else>
            Disburse Loan
          </span>
        </button>
      </template>
    </CModal>
    <CModal v-show="isRepayVisible" @close="closeRepayModal" footer>
      <template v-slot:title>
        <h5 class=" fw-bold">Force Repayment</h5>
      </template>
      <template v-slot:body>
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="">Payment Method</label>
              <select name="" v-model="payment_method" id="" class="form-control">
                <option value="" selected disabled>Please Select Payment Method</option>
                <option value="core-banking">Core Banking</option>
                <option value="card">Card</option>
              </select>
            </div>
            <div class="form-group" v-if="payment_method === 'card'">
              <label for="">Choose Card</label>
              <select class="form-control" name="" id="" v-model="card_id">
                <option value="" selected disabled>Please Choose Card</option>
                <option :value="item.id" v-for="(item, index) in loanCards" :key="index">
                  {{ item.c_mask_pan }}
                </option>
              </select>
            </div>
            <div class="form-group">
              <label for="">Amount</label>
              <input type="text" class="form-control" @keypress="isNumber($event)" v-model="amount"
                placeholder="Enter Amount" />
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <button class=" btn btn-secondary" @click="closeRepayModal">
          Close
        </button>
        <button class=" btn btn-primary" @click="repayAction" :disabled="!repayFormIsValid || formLoading">
          <span class="custom-loader" v-if="formLoading">
            <loader-icon size="1.5x" class="custom-class"></loader-icon>
            <span style="font-weight: 600; text-transform: initial;">Please wait</span>
          </span>
          <span v-else>
            Perform Action
          </span>
        </button>
      </template>
    </CModal>
    <CModal v-show="isWaveVisible" @close="closeWaveModal" footer>
      <template v-slot:title>
        <h5 class=" fw-bold">Wave Request</h5>
      </template>
      <template v-slot:body>
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="">Amount</label>
              <input type="text" class="form-control" @keypress="isNumber($event)" v-model="requested_amount"
                placeholder="Enter Amount" />
            </div>
            <div class="form-group">
              <label for="">Reason</label>
              <textarea name="" id="" cols="30" rows="4" v-model="reason" style="resize: none"
                class="form-control"></textarea>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <button class=" btn btn-secondary" @click="closeWaveModal">
          Close
        </button>
        <button class=" btn btn-primary" @click="waveRequest"
          :disabled="requested_amount === '' || reason === '' || formLoading">
          <span class="custom-loader" v-if="formLoading">
            <loader-icon size="1.5x" class="custom-class"></loader-icon>
            <span style="font-weight: 600; text-transform: initial;">Please wait</span>
          </span>
          <span v-else>
            Perform Action
          </span>
        </button>
      </template>
    </CModal>

    <form @submit.prevent="overturnReviewAction">
      <modal v-show="isOverturnModalVisible" @close="openOverturnModal" footer>
        <template v-slot:title>
          <h5>Overturn Message</h5>
        </template>
        <template v-slot:body>
          <div class=" form-group">
            <label for="message">Message</label>
            <textarea name="" id="" cols="30" class=" form-control" rows="10" v-model="message" style="resize: none"
              placeholder="Message"></textarea>
          </div>
        </template>
        <template v-slot:footer>
          <button type="submit" class="button" :disabled="message === '' || overturnLoading">
            <span v-if="overturnLoading">Please wait...</span>
            <span v-else>Proceed</span>
          </button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="openOverturnModal">
            Cancel
          </button>
        </template>
      </modal>
    </form>
    <!-- openQAModal
    addLoanQAFunc
    loanQAObj
    isLoanQAModalOpen
    isLoanQALoading -->
    <form @submit.prevent="addLoanQAFunc">
      <modal v-show="isLoanQAModalOpen" @close="openQAModal" footer>
        <template v-slot:title>
          <h5>Add Loan QA</h5>
        </template>

        <template v-slot:body>
          <div class="form-group">
            <label for="">Ratings</label>
            <select name="" id="" class="form-control" v-model="loanQAObj.rating">
              <option value="" disabled selected>Please select</option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
            </select>
          </div>

          <div class="form-group">
            <label for="comment">Comment</label>
            <textarea name="" class="form-control" id="" cols="30" rows="10" style="resize: none"
              v-model="loanQAObj.comment"></textarea>
          </div>
        </template>

        <template v-slot:footer>
          <button type="submit" class="button" :disabled="loanQAObj.rating === '' ||
            loanQAObj.comment === '' ||
            isLoanQALoading
            ">
            <span v-if="isLoanQALoading">Please wait...</span>
            <span v-else>Proceed</span>
          </button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="openQAModal">
            Cancel
          </button>
        </template>
      </modal>
    </form>
    <div v-if="pageLoading"
      style="display: flex; top: 0px; position: fixed; left: 0px; right: 0px; bottom: 0px; background-color: rgba(247, 247, 247, 0.6); z-index: 9999; justify-content: center; align-items: center;">
      <div>
        <div>
          <h3 v-if="pageLoading">
            {{ loader_message }}
          </h3>
        </div>
      </div>
    </div>

    <div class=" main-menu-content" v-if="loanData !== null">
      <div @click="$router.go(-1)" class=" arrow_text cursor-pointer width-100">
        <chevron-left-icon size="1.5x" class="custom-class" style="vertical-align: top;"></chevron-left-icon>
        <span class="back">Back</span>
      </div>

      <h3 class=" font-regular mb-2 mt-1">
        Loan One Profile
      </h3>

      <div class="row mb-2">
        <div class="col-lg-12">
          <CScrollbar class="nav nav-tabs nav-overflow header-tabs" :settings="psSettings" tag="ul">
            <li class="nav-item">
              <a class="nav-link" href="javascript:void(0)" v-on:click="activetab = 1"
                v-bind:class="[activetab === 1 ? 'active' : '']">General Info</a>
            </li>

            <li class="nav-item" v-if="permissions.includes('loan-contacts')">
              <a class="nav-link" href="javascript:void(0)" v-on:click="activetab = 2"
                v-bind:class="[activetab === 2 ? 'active' : '']">Address Book</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="javascript:void(0)" v-on:click="activetab = 3"
                v-bind:class="[activetab === 3 ? 'active' : '']">Repayment Records</a>
            </li>
            <li class="nav-item" v-if="permissions.includes('collections')">
              <a class="nav-link" href="javascript:void(0)" v-on:click="activetab = 4"
                v-bind:class="[activetab === 4 ? 'active' : '']">Collection Information</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="javascript:void(0)" v-on:click="activetab = 5"
                v-bind:class="[activetab === 5 ? 'active' : '']">Loan History</a>
            </li>
            <li class="nav-item" v-if="permissions.includes('disbursements')">
              <a class="nav-link" href="javascript:void(0)" v-on:click="activetab = 6"
                v-bind:class="[activetab === 6 ? 'active' : '']">Disbursement</a>
            </li>

            <li class="nav-item" v-if="permissions.includes('loan-qa')">
              <a href="javascript:void(0)" class="nav-link" v-on:click="activetab = 8"
                v-bind:class="[activetab === 8 ? 'active' : '']">
                Loan QAs</a>
            </li>
            <li class="nav-item" v-if="permissions.includes('waviers') ||
              permissions.includes('create-wavier')
            ">
              <a class="nav-link" href="javascript:void(0)" v-on:click="activetab = 7"
                v-bind:class="[activetab === 7 ? 'active' : '']">Waivers</a>
            </li>
            <li class="nav-item" v-if="permissions.includes('pull-credit-report') ||
              permissions.includes('credit-report')
            ">
              <a class="nav-link" href="javascript:void(0)" v-on:click="activetab = 13"
                v-bind:class="[activetab === 13 ? 'active' : '']">Credit Report</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="javascript:void(0)" v-on:click="activetab = 14"
                v-bind:class="[activetab === 14 ? 'active' : '']">Contact Analysis</a>
            </li>
          </CScrollbar>
        </div>
      </div>

      <h5 class="font-regular mb-1 mt-1">
        <span class="  font-bold">Current Address:</span>
        {{ loanData.current_address }}
      </h5>

      <h6 class="font-regular mb-1 mt-0">
        <span class=" font-bold">Current Coordinates:</span>
        {{ loanData.current_coordianates }}
      </h6>
      <button class="btn btn-primary d-block my-2" @click="openModal" v-if="
        permissions.includes('update-loan-status')
      ">
        Update Loan Status
      </button>
      <!-- loans qas -->
      <div class="p-2" v-if="activetab === 8">
        <div class="row justify-content-end">
          <button class="btn btn-primary col-auto" @click="openQAModal" v-if="permissions.includes('add-loan-qa')">
            Add Loan QA
          </button>
        </div>

        <div class="row">
          <div class="col-md-6 shadow-lg p-1 rounded-sm" v-for="(item, index) in loanData.qas" :key="index">
            <KeyValue objKey="Ratings:" :objValue="item.rating" />
            <KeyValue objKey="Comment:" :objValue="item.comment" />
            <KeyValue objKey="Reviewer:" :objValue="`${item.reviewer.first_name} ${item.reviewer.last_name}`
              " />
          </div>
        </div>
      </div>
      <!-- General Info -->
      <div class="row" v-if="activetab === 1">
        <div class="col-md-4">
          <div class="card card--no-shadow card-profile">
            <div class="card-header">
              <h3 class="font-weight-600 mb-0">Loan Info</h3>
            </div>
            <div class="card-content">
              <div class="card-body">
                <KeyValue objKey="Auto Check Status" :objValue="loanData.auto_check_status" />
                <KeyValue objKey="Requested loan" :objValue="loanData.requested_loan_amount" :showCurrency="true" />
                <KeyValue objKey="Approved Loan Amount" :objValue="loanData.approved_loan_amount"
                  :showCurrency="true" />
                <KeyValue objKey="Daily Penalty Fee" :objValue="loanData.daily_penalty_fee" :showCurrency="true" />
                <KeyValue objKey="Interest Amount" :objValue="loanData.interest_amount" :showCurrency="true" />
                <KeyValue objKey="Interest Rate" :objValue="loanData.interest_rate" :showPercent="true" />
                <KeyValue objKey="Charges" :objValue="loanData.charges" :showCurrency="true" />
                <KeyValue objKey="Interest Sweep Amount" :objValue="loanData.interest_sweep_amount" :showCurrency="true" />
                <KeyValue objKey="Interest Moved At" :objValue="loanData.interest_transferred_at | date_two" />
                <KeyValue objKey="Charge Sweep Amount" :objValue="loanData.charge_sweep_amount" :showCurrency="true" />
                <KeyValue objKey="Charges Moved At" :objValue="loanData.charges_transferred_at | date_two" />
                <div
                  class="mt-3 mb-2"
                  v-if="loanData.loan_status === 'completed' &&
                    loanData.income_sweep_eligible &&
                    permissions.includes('disburse-instant-loan') &&
                    (!loanData.interest_transferred_at || !loanData.charges_transferred_at)"
                >
                  <button
                    class="btn btn-info btn-sm mr-2 mb-2"
                    @click.prevent="retriggerIncomeSweep('interest')"
                    :disabled="incomeSweepLoading || !!loanData.interest_transferred_at"
                    v-if="!loanData.interest_transferred_at"
                  >
                    <span v-if="incomeSweepLoading">Please wait...</span>
                    <span v-else>Sweep Interest</span>
                  </button>
                  <button
                    class="btn btn-info btn-sm mb-2"
                    @click.prevent="retriggerIncomeSweep('charges')"
                    :disabled="incomeSweepLoading || !!loanData.charges_transferred_at"
                    v-if="!loanData.charges_transferred_at"
                  >
                    <span v-if="incomeSweepLoading">Please wait...</span>
                    <span v-else>Sweep Charges</span>
                  </button>
                </div>
                <KeyValue objKey="Created Date" :objValue="loanData.created_at | date_two" />
                <KeyValue objKey="Disbursed Status" :objValue="loanData.disbursed_status" />
                <KeyValue objKey="Disbursed Date" :objValue="loanData.disbursed_date | date_two" />
                <KeyValue objKey="Overturn Message" :objValue="loanData.overturn_message" />
                <KeyValue objKey="Overturn Date" :objValue="loanData.overturn_date | date_two" />
                <KeyValue objKey="Discount" :objValue="loanData.discount" :showCurrency="true" />

                <KeyValue objKey="Last Collection Date" :objValue="loanData.last_collection_date | date_two" />
                <KeyValue objKey="Last Repayment Date" :objValue="loanData.last_repayment_date | date_two" />
                <KeyValue objKey="Last Repayment Method" :objValue="loanData.last_repayment_method" />
                <KeyValue objKey="Loan Status" :objValue="loanData.loan_status" />
                <KeyValue objKey="Overdue Date" :objValue="loanData.due_date" />
                <KeyValue objKey="No of Overdue Days" :objValue="loanData.no_of_overdue_days" />
                <KeyValue objKey="Penalty Amount" :objValue="loanData.penalty_amount" :showCurrency="true" />
                <KeyValue objKey="Remaining Balance" :objValue="loanData.remaining_balance" :showCurrency="true" />
                <KeyValue objKey="Last Repayment Date" :objValue="loanData.last_repayment_date" :showCurrency="true" />
                <KeyValue objKey="Repayed Amount" :objValue="loanData.repayed_amount" :showCurrency="true" />
                <KeyValue objKey="Repayment Status" :objValue="loanData.repayment_status" />
                <KeyValue objKey="Tenure" :objValue="loanData.tenure" />
                <KeyValue objKey="Total Amount" :objValue="loanData.total_amount" :showCurrency="true" />
                <KeyValue objKey="Review Date" :objValue="loanData.review_date | date_two" />
                <KeyValue objKey="Review Status" :objValue="loanData.review_status" />
                <KeyValue objKey="Review Status Details" :objValue="loanData.review_status_details" />
                <KeyValue objKey="Review Status Reason" :objValue="loanData.review_status_reason" />

                <KeyValue v-if="loanData.review_user_details" objKey="Reviewed By" :objValue="`${loanData.review_user_details.first_name} ${loanData.review_user_details.last_name}`
                  " />
              </div>
            </div>
            <div class=" card-footer">
              <div class="row justify-content-around">
                <button class="btn btn-warning my-2" @click.prevent="openOverturnModal" v-if="loanData.loan_status === 'awaiting-disbursement' &&
                  permissions.includes('overturn-loan-review')
                ">
                  <span v-if="overturnLoading">Please wait...</span>
                  <span v-else>Overturn Loan Review</span>
                </button>

                <button class=" btn btn-primary w-auto" @click.prevent="closeReviewModal" v-if="loanData.loan_status === 'pending' &&
                  permissions.includes('review-instant-loan')
                ">
                  Review
                </button>
                <button class="btn btn-danger w-auto">Review Record</button>
                <button class="btn btn-danger w-auto" @click.prevent="cancelDisbursement" v-if="loanData.loan_status === 'awaiting-disbursement' &&
                  permissions.includes('cancel-disbursement') && loanData.disbursed_status === 'in-progress'
                ">Cancel Disbursement</button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card card--no-shadow card-profile">
            <div class="card-header">
              <h3 class="font-weight-600 mb-0">Personal Info</h3>
            </div>
            <div class="card-content">
              <div class="card-body">
                <KeyValue objKey="First Name" :objValue="loanData.user.first_name" />
                <KeyValue objKey="Last Name" :objValue="loanData.user.last_name" />
                <KeyValue objKey="Other Name" :objValue="loanData.user.other_name" />
                <KeyValue objKey="Customer Level" :objValue="loanData.user.kyc.kyc_level_name" />
                <KeyValue objKey="Date Of Birth" :objValue="loanData.user.date_of_birth | date_two" />
                <KeyValue objKey="Age" :objValue="loanData.user.date_of_birth | date_three" />
                <KeyValue objKey="Email" :objValue="loanData.user.email" />
                <KeyValue objKey="Gender" :objValue="loanData.user.gender" />
                <KeyValue objKey="Phone Number" :objValue="loanData.user.phone_number" />
                <KeyValue objKey="BVN" :objValue="loanData.user.kyc.bvn" />
                <KeyValue objKey="BVN Status" :objValue="loanData.user.kyc.bvn_status" />
                <KeyValue objKey="Address" :objValue="loanData.user.kyc.address" />
                <KeyValue objKey="City" :objValue="loanData.user.kyc.city" />

                <KeyValue objKey="Next of Kin" :objValue="`${loanData.user.kyc.nok_firstname
                  ? loanData.user.kyc.nok_firstname
                  : ''
                  } ${loanData.user.kyc.nok_lastname
                    ? loanData.user.kyc.nok_lastname
                    : ''
                  }`
                  " />
                <KeyValue objKey="NOK Email" :objValue="loanData.user.kyc.nok_email" />
                <KeyValue objKey="NOK Phone Number" :objValue="loanData.user.kyc.nok_phone_number" />
                <KeyValue objKey="NOK Address" :objValue="loanData.user.kyc.nok_full_address" />
              </div>
            </div>
            <div class=" card-footer">
              <div class="row justify-content-around">
                <button v-if="permissions.includes('view-customer')" class=" btn btn-primary w-auto"
                  @click="openNewTab(loanData.user_id)">
                  More Info
                </button>
              </div>
            </div>
          </div>
          <div class=" card card--no-shadow card-profile">
            <div class="card-header">
              <h3 class="font-weight-600 mb-0">Loan Profile</h3>
            </div>
            <div class="card-content">
              <div class="card-body">
                <KeyValue objKey="Company Address" :objValue="loanData.user.loan_profile.company_address" />
                <KeyValue objKey="Company Name" :objValue="loanData.user.loan_profile.company_name" />
                <KeyValue objKey="Company Phone Number" :objValue="loanData.user.loan_profile.company_phone_number" />
                <KeyValue objKey="Contact One" :objValue="loanData.user.loan_profile.contact_one_name" />
                <KeyValue objKey="Company One Phone Number" :objValue="loanData.user.loan_profile.contact_one_phone_number
                  " />

                <verify-identity identityType="phone" identityName="Phone Number" :identifier="loanData.user.loan_profile.contact_one_phone_number
                  " v-if="loanData.user.loan_profile.contact_one_phone_number !==
                    null &&
                    loanData.user.loan_profile.contact_one_phone_number !== ''
                  " />
                <KeyValue objKey="Company One Relationship" :objValue="loanData.user.loan_profile.contact_one_relationship
                  " />
                <KeyValue objKey="Contact Two" :objValue="loanData.user.loan_profile.contact_two_name" />
                <KeyValue objKey="Company Two Phone Number" :objValue="loanData.user.loan_profile.contact_two_phone_number
                  " />

                <verify-identity identityType="phone" identityName="Phone Number" :identifier="loanData.user.loan_profile.contact_two_phone_number
                  " v-if="loanData.user.loan_profile.contact_two_phone_number !==
                    null &&
                    loanData.user.loan_profile.contact_two_phone_number !== ''
                  " />

                <KeyValue objKey="Company Two Relationship" :objValue="loanData.user.loan_profile.contact_two_relationship
                  " />
                <KeyValue objKey="Employment Status" :objValue="loanData.user.loan_profile.employment_status" />
                <!-- <KeyValue
                  objKey="Is Loan Profile Completed"
                  :objValue="
                    loanData.user.loan_profile.is_loan_profile_completed
                  "
                /> -->
                <KeyValue objKey="Loan Standing" :objValue="loanData.user.loan_profile.loan_standing" />
                <KeyValue objKey="Monthly Income" :objValue="loanData.user.loan_profile.monthly_income" />
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 flex-column">
          <magnifier title="BVN Image" :imageSrc="bvn_image" v-if="bvn_image !== ''" />

          <magnifier v-if="loanData.loan_photo !== '' && loanData.loan_data !== null" title="Customer's Image"
            :imageSrc="loanData.loan_photo" />
        </div>
      </div>
      <!-- Address Book -->
      <div v-if="activetab === 2" class="p-2">
        <div class="p-2">
          <h4>Address book</h4>
        </div>
        <CDataTable :itemsPerPage="100" :items="contacts" :fields="addressBookFields" tableFilter pagination>
          <template #action="{ item }">
            <td>
              <button class="btn btn-primary btn-sm" @click="callContact(item.phone)">
                View
              </button>
            </td>
          </template>
        </CDataTable>
      </div>
      <!-- Repayment -->
      <div v-if="activetab === 3" class="p-2">
        <div class="p-2 d-flex justify-content-between">
          <h4>Repayment Records</h4>
          <button class="btn btn-primary" @click="openRepayModal" v-if="permissions.includes('repay-instant-loan')">
            Repay Action
          </button>
        </div>
        <CDataTable :items="loanData.repayments" :fields="repayFields" pagination>
          <template #time="{ item }">
            <td>
              {{ item.created_at | date }}
            </td>
          </template>
        </CDataTable>
      </div>
      <!-- collections -->
      <div v-if="activetab === 4" class="p-2">
        <div class=" row justify-content-start p-2">
          <button class="col-auto me-1 btn btn-primary" @click="closeCollectionModal" v-if="(loanData.loan_status === 'active' || loanData.loan_status === 'overdue') &&
            permissions.includes('create-collection')
          ">
            Add
          </button>
          <button class="col-auto me-1 btn btn-primary">Reduce</button>
          <button class="col-auto me-1 btn btn-primary">Debit</button>
        </div>
        <div class="p-2">
          <h4>Collection History</h4>
        </div>
        <CDataTable :items="loanData.collections" :fields="collectionFields" pagination>
          <template #collection_time="{ item }">
            <td>
              {{ item.created_at | date }}
            </td>
          </template>
          <template #collector="{ item }">
            <td>
              {{
                `${item.collection_user_detail.first_name} ${item.collection_user_detail.last_name} `
              }}
            </td>
          </template>
        </CDataTable>
      </div>
      <!-- Loan History -->
      <div v-if="activetab === 5" class="p-2">
        <div class="p-2">
          <h4>Loan Order History</h4>
        </div>
        <CDataTable :items="histories" :fields="historyFields" sorter :itemsPerPage="30">
          <template #name="{ item }">
            <td>
              {{ `${item.user.first_name} ${item.user.last_name}` }}
            </td>
          </template>

          <template #phone="{ item }">
            <td>
              {{ item.user.phone_number }}
            </td>
          </template>
          <template #bvn="{ item }">
            <td>
              {{ item.user.kyc.bvn }}
            </td>
          </template>
          <template #created_at="{ item }">
            <td>
              {{ item.created_at | date }}
              <!-- {{
                      item.created_at === null
                        ? ""
                        : `${item.created_at | date}`
                    }} -->
            </td>
          </template>
          <template #due_date="{ item }">
            <td>
              {{ item.due_date | date }}
            </td>
          </template>
          <template #disbursed_date="{ item }">
            <td>
              {{ item.disbursed_date | date }}
            </td>
          </template>
          <template #action="{ item }">
            <td>
              <button v-if="permissions.includes('view-instant-loan')" class=" btn btn-primary w-auto"
                @click="openNewLoanTab(item.instant_reference)">
                View
              </button>
              <!-- <router-link
                v-if="permissions.includes('view-instant-loan')"
                :to="{
                  name: 'LoanComponent',
                  params: { slug: item.instant_reference }
                }"
                class="button"
              >
                View</router-link
              > -->
              <!-- {{ item.disbursed_date | date }} -->
            </td>
          </template>
        </CDataTable>
      </div>
      <!-- Disbursement Table -->
      <div v-if="activetab === 6" class="p-2">
        <div class=" row justify-content-end">
          <div class="col-auto" v-if="loanData.loan_status === 'awaiting-disbursement' &&
            permissions.includes('disburse-instant-loan')
          ">
            <button class=" btn btn-primary" @click.prevent="openDisburseModal">
              Disburse Loan
            </button>
          </div>
        </div>

        <div class="p-2">
          <h4>Disbursement</h4>
        </div>
        <CDataTable :items="loanData.disbursements" :fields="disburseFields" pagination>
          <template #disbursed_user="{ item }">
            <td>
              {{
                `${item.disburse_user_detail.first_name} ${item.disburse_user_detail.last_name} `
              }}
            </td>
          </template>
          <template #created_at="{ item }">
            <td>
              {{ item.created_at | date }}
            </td>
          </template>

          <template #action="{ item }">
            <td>
              <button @click="console.log(item.id)" class="btn btn-warning">
                Query Disburse
              </button>
            </td>
          </template>
        </CDataTable>
      </div>

      <!-- waivers -->

      <div v-if="activetab === 7" class="p-2">
        <div class="p-2 d-flex justify-content-between">
          <h4>Waivers</h4>
          <button class="btn btn-primary" @click="openWaveModal" v-if="permissions.includes('create-wavier')">
            Create Waiver Request
          </button>
        </div>
        <CDataTable :items="loanData.waviers" :fields="waveFields" pagination v-if="permissions.includes('waviers')">
          <template #requested_by="{ item }">
            <td>
              {{
                `${item.requested_by_detail.first_name} ${item.requested_by_detail.last_name}`
              }}
            </td>
          </template>
          <template #time="{ item }">
            <td>
              {{ item.created_at | date }}
            </td>
          </template>
        </CDataTable>
      </div>

      <!-- supporting Document -->
      <div v-if="activetab === 12" class="p-2">
        <div class="p-2 d-flex justify-content-between">
          <h4>Supporting Document</h4>
          <button class="btn btn-primary" @click="openWaveModal" v-if="permissions.includes('create-wavier')">
            Create Waiver Request
          </button>
        </div>
        <CDataTable :items="loanData.waviers" :fields="waveFields" pagination v-if="permissions.includes('waviers')">
          <template #requested_by="{ item }">
            <td>
              {{
                `${item.requested_by_detail.first_name} ${item.requested_by_detail.last_name}`
              }}
            </td>
          </template>
          <template #time="{ item }">
            <td>
              {{ item.created_at | date }}
            </td>
          </template>
        </CDataTable>
      </div>

      <div v-if="activetab === 13" class="p-2">
        <h4>Credit Report</h4>
        <div v-if="!credit_report">
          <button class="btn btn-primary" @click="pullCreditReportByUser" :disabled="formLoading"
            v-if="permissions.includes('pull-credit-report')">
            <span class="custom-loader" v-if="formLoading">
              <loader-icon size="1.5x" class="custom-class"></loader-icon>
              <span style="font-weight: 600; text-transform: initial;">Please wait</span>
            </span>
            <span v-else> Pull Credit Report</span>
          </button>
        </div>

        <div class="row" v-if="credit_report">
          <div class="col-md-4">
            <div class="card card--no-shadow card-profile">
              <div class="card-header">
                <h3 class="font-weight-600 mb-0">Scoring</h3>
              </div>
              <div class="card-content">
                <div class="card-body">
                  <KeyValue objKey="Score Risk" :objValue="credit_report.score_description" />
                  <KeyValue objKey="Repayment History Score" :objValue="credit_report.repayment_history_score" />
                  <KeyValue objKey="Total Amount Owned Score" :objValue="credit_report.total_amount_owned_score" />
                  <KeyValue objKey="Type of Credit Score" :objValue="credit_report.types_of_credit_score" />
                  <KeyValue objKey="Length of Credit History Score"
                    :objValue="credit_report.length_of_credit_history_score" />
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="card card--no-shadow card-profile">
              <div class="card-header">
                <h3 class="font-weight-600 mb-0">Account</h3>
              </div>
              <div class="card-content">
                <div class="card-body">
                  <div class="transaction-details" v-for="(value, name, index) in credit_report.credit_account_summary"
                    :key="index">
                    <KeyValue :objKey="name" :objValue="value" v-if="value != '0'" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <CDataTable :items="credit_report.credit_agreement_summary" :fields="creditAgreementSummaryFields"
              pagination>
            </CDataTable>
          </div>
        </div>
      </div>
      <div v-if="activetab === 14" class="p-2">
        <h4>Contact Analysis</h4>
        <button class="btn btn-primary" @click="getContactAnalysis" :disabled="contactAnalysisLoading">
          <span class="custom-loader" v-if="contactAnalysisLoading">
            <loader-icon size="1.5x" class="custom-class"></loader-icon>
            <span style="font-weight: 600; text-transform: initial;">Please wait</span>
          </span>
          <span v-else> Pull Contact Analysis</span>
        </button>
        <div class="row" v-if="contactAnalysisData">
          <h4>No of Occurence : {{contactAnalysisData.no_of_contacts}}</h4>
          <div class="col-md-12">
            <CDataTable :items="contactAnalysisData.contacts" :fields="contactAnalysisFields" :itemsPerPage="100" tableFilter pagination>
                <template #owner="{ item }">
                  <td>
                    {{
                      `${item.user.first_name} ${item.user.last_name}`
                    }}
                    <br>
                    <span v-if="item.user.is_marketer === 'yes'" class="badge badge-success">Marketer</span>
                  </td>
                </template>
            </CDataTable>
          </div>
        </div>
      </div>

    </div>
    <modal v-show="showUpdateModal" @close="closeModal" modalIsLarge footer>
      <template v-slot:title>
        <h5>Update Loan Status</h5>
      </template>
      <template v-slot:body>
        <div class=" form-group">
          <label>Status</label>
          <select v-model="statusQuery" class="form-control">
            <option value="" selected disabled>Please Select Status </option>
            <option value="active">Active</option>
            <option value="overdue">Overdue</option>
            <option value="completed">Completed</option>
            <option value="refused">Refused</option>
            <option value="refused-and-reapply">Refused and ReApply</option>
            <!-- <option value="reversed">Reversed</option> -->
          </select>
        </div>
      </template>
      <template v-slot:footer>
        <button type="button" class="button" @click.prevent="upadateLoanStatusAction"
          :disabled="statusLoading || statusQuery === ''">
          <span class="custom-loader" v-if="statusLoading">
            <loader-icon size="1.5x" class="custom-class"></loader-icon>
            <span style="font-weight: 600; text-transform: initial;">Please wait...</span>
          </span>
          <span v-else>
            Update Status
          </span>
        </button>
        <button @click="closeModal" class="btn btn-secondary">
          Cancel
        </button>
      </template>
    </modal>
  </div>
</template>

<script>
import KeyValue from "../../components/KeyValue.vue";
import CCard from "../../components/CCard.vue";
import CScrollbar from "../../components/CScrollbar.vue";
import img from "@/assets/img/team.jpg";
import Swal from "sweetalert2";
import CDataTable from "../../components/CDataTable.vue";
import ApiService from "../../services/api.service";
import CModal from "../../components/CModal.vue";
import ErrorService from "../../services/error.service";
import VerifyIdentity from "../../components/VerifyIdentity.vue";
const disburseFields = [
  "disbursed_user",
  "charge",
  "amount",
  "total_amount",

  "payment_status",
  "payment_provider",
  "payment_reference",
  "external_reference",
  "status",
  "created_at",
  "action"
];
const repayFields = [
  "amount",
  "payment_method",
  "payment_status",
  "status",
  "time"
];

const waveFields = [
  "requested_amount",
  "approved_amount",
  "status",
  "requested_by",
  "treated_by",
  "created_at"
];

const addressBookFields = [
  "name", 
  "phone",
  "action"
];

const collectionFields = [
  // "order_no",
  "collector",
  "collection_time",
  "collection_method",
  "collection_object",
  "collection_object_name",
  "collection_phone",
  "collection_result",
  "collection_details"
];

const contactAnalysisFields = [
  'owner',
  'name',
  'phone',  
  'action',
];

const historyFields = [
  "action",
  "name",
  "due_date",
  "no_of_overdue_days",
  "instant_reference",
  "loan_status",
  "review_status",
  "disbursed_status",
  "tenure",
  "repayment_status",
  "requested_loan_amount",
  "approved_loan_amount",
  "charges",
  "created_at",
  "disbursed_date",
];

const creditAgreementSummaryFields = [
  'DateAccountOpened',
  'ClosedDate',
  'SubscriberName',
  'IndicatorDescription',
  "OpeningBalanceAmt",
  'CurrentBalanceAmt',
  'AmountOverdue',
  'AccountStatus',
  'PerformanceStatus'
]


export default {
  name: "LoanComponent",
  props: {
    slug: {
      type: [String, Number],
      required: true
    }
  },
  components: {
    CModal,
    CCard,
    KeyValue,
    CScrollbar,
    CDataTable,
    VerifyIdentity
  },
  computed: {
    userObj() {
      return this.$store.getters.userObj;
    },
    psSettings() {
      return {
        maxScrollbarLength: 200,
        minScrollbarLength: 40,
        suppressScrollX:
          getComputedStyle(document.querySelector("html")).direction === "rtl",
        wheelPropagation: false
      };
    },
    permissions() {
      let permissions = this.$store.getters.permissions;
      return permissions;
    },
    repayFormIsValid() {
      if (this.payment_method !== "") {
        if (this.payment_method === "core-banking") {
          return this.amount !== "";
        } else {
          return this.card_id !== "" && this.amount !== "";
        }
      } else {
        return false;
      }
    },
    formIsValid() {
      return (
        this.collection.collection_method !== "" &&
        this.collection.collection_object !== "" &&
        this.collection.collection_object_name !== "" &&
        this.collection.collection_phone !== "" &&
        this.collection.collection_result !== "" &&
        this.collection.collection_details !== ""
      );
    }
  },
  data() {
    return {
      contactAnalysisLoading : false,
      contactAnalysisData : null,
      statusLoading: false,
      isLoanQALoading: false,
      isLoanQAModalOpen: false,
      credit_report: null,
      loanQAObj: {
        comment: "",
        instant_reference: this.slug,
        rating: ""
      },
      // name: userObj.first_name,
      bvn_image: "",
      waveFields,
      isWaveVisible: false,
      reason: "We're waiving the loan amount because of Death",
      requested_amount: "1000",
      r_status: "",
      r_reason: "",
      r_details: "",
      isReviewModalVisible: false,
      disburseFields,
      creditAgreementSummaryFields,
      historyFields,
      contactAnalysisFields,
      histories: [],
      collectionFields,
      repayFields,
      addressBookFields,
      contacts: [],
      img,
      // filePath: "@/assets/img/team.jpg",
      pageLoading: false,
      activetab: 1,
      imageModalQuery: "",
      loanData: null,
      formLoading: false,
      incomeSweepLoading: false,
      disburse: {
        payment_method: "",
        disbursed_status: ""
      },
      isDisburseModalVisible: false,
      isCollectionModalVisible: false,
      collection: {
        collection_method: "",
        collection_object: "",
        collection_object_name: ``,
        collection_phone: "",
        collection_result: "",
        collection_details: ""
      },
      loanCards: [],
      payment_method: "",
      amount: "",
      card_id: "",
      isRepayVisible: false,
      // overturnReviewAction
      isOverturnModalVisible: false,
      overturnLoading: false,
      message: "",
      showUpdateModal: false,
      statusQuery: '',
      loader_message: "Please wait...",
    };
  },
  methods: {
    async openModal() {
      console.log("hello");
      this.showUpdateModal = true;
    },
    async closeModal() {
      this.showUpdateModal = false;
      this.statusQuery = "";
    },
    openQAModal() {
      this.isLoanQAModalOpen = !this.isLoanQAModalOpen;
      this.loanQAObj.comment = "";
      this.loanQAObj.rating = "";
    },
    async addLoanQAFunc() {
      try {
        this.isLoanQALoading = true;
        const response = await ApiService.post(
          "loan/instant/add_loan_qa",
          this.loanQAObj
        );
        console.log(response);
        Swal.fire({
          title: "Success",
          text: response.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        this.isLoanQALoading = false;
        this.getLoan();
        this.openQAModal();
      } catch (error) {
        this.openQAModal();

        this.isLoanQALoading = false;
        console.log(error.response);
        // this.closeSendMessageModal();
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
      }
    },
    openOverturnModal() {
      this.isOverturnModalVisible = !this.isOverturnModalVisible;
    },
    async overturnReviewAction() {
      try {
        this.overturnLoading = true;
        const response = await ApiService.post(
          "loan/instant/overtune_loan_review",
          { instant_reference: this.slug, overturn_message: this.message }
        );
        console.log(response);
        Swal.fire({
          title: "Success",
          text: response.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        this.overturnLoading = false;
        this.getLoan();
        this.openOverturnModal();
      } catch (error) {
        this.openOverturnModal();

        this.overturnLoading = false;
        console.log(error.response);
        // this.closeSendMessageModal();
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
      }
    },
    openNewTab(id) {
      const newTabUrl = `/customers/${id}`; // Replace with your desired route path
      window.open(newTabUrl, "_blank");
    },

    openNewLoanTab(id) {
      const newTabUrl = `/loans/${id}`;
      window.open(newTabUrl, "_blank");
    },
    openWaveModal() {
      this.isWaveVisible = true;
    },
    closeWaveModal() {
      this.isWaveVisible = false;
      this.reason = "";
      this.requested_amount = "";
    },
    waveRequest() {
      this.isWaveVisible = false;
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger me-2",
          title: "text-center h6 fw-bold text-black d-block"
        },
        buttonsStyling: false
      });

      swalWithBootstrapButtons
        .fire({
          title: `Are you sure you want to perform this action</span>`,
          text: "You won't be able to revert",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, continue!",
          cancelButtonText: "No Cancel",
          reverseButtons: true
        })
        .then(result => {
          if (result.isConfirmed) {
            this.waveAction();
          } else if (result.dismiss == Swal.DismissReason.cancel) {
            swalWithBootstrapButtons.fire(
              "Cancelled",
              "Your transaction hasn't change",
              "error"
            );
          }
        });
    },
    async cancelDisbursement() {
      this.isWaveVisible = false;
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger me-2",
          title: "text-center h6 fw-bold text-black d-block"
        },
        buttonsStyling: false
      });

      const confirm = await swalWithBootstrapButtons
        .fire({
          title: `Are you sure you want to cancel Disbursement</span>`,
          text: "You won't be able to revert",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, continue!",
          cancelButtonText: "No Cancel",
          reverseButtons: true
        })

      if (confirm.isConfirmed) {
        try {
          this.formLoading = true;
          const res = await ApiService.post("loan/instant/cancel_disbursement", {
            instant_reference: this.slug
          });
          this.formLoading = false;
          Swal.fire({
            title: "Success",
            text: res.data.message,
            icon: "success",
            timer: 3000,
            confirmButtonText: "Close",
            showConfirmButton: false
          });
          this.getLoan();
        } catch (error) {
          this.formLoading = false;
          let _error = error.response.data;

          ErrorService.displayErrorAlert(_error);
        }
      } else if (confirm.dismiss == Swal.DismissReason.cancel) {
        swalWithBootstrapButtons.fire(
          "Cancelled",
          "Your transaction hasn't change",
          "error"
        );
      }
        
    },
    async waveAction() {
      try {
        this.isWaveVisible = true;
        this.formLoading = true;
        const res = await ApiService.post("loan/instant/create-wavier", {
          instant_reference: this.slug,
          reason: this.reason,
          requested_amount: this.requested_amount
        });
        this.formLoading = false;
        this.closeWaveModal();
        Swal.fire({
          title: "Success",
          text: res.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        this.getLoan();
      } catch (error) {
        this.formLoading = false;
        let _error = error.response.data;

        ErrorService.displayErrorAlert(_error);
      }
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    async createCollection() {
      this.formLoading = true;
      try {
        console.log("Hello World");
        const res = await ApiService.post("loan/instant/create-collection", {
          ...this.collection,
          instant_reference: this.slug
        });
        this.closeCollectionModal();
        Swal.fire({
          title: "Success",
          text: res.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });

        setTimeout(() => this.getLoan(), 4000);
        this.formLoading = false;
      } catch (error) {
        console.log(error);
        this.closeCollectionModal();
        this.formLoading = false;
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
      }
    },
    async closeCollectionModal() {
      this.isCollectionModalVisible = !this.isCollectionModalVisible;
    },
    async disburseLoan() {
      this.isDisburseModalVisible = false;
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger me-2",
          title: "text-center h6 fw-bold text-black d-block"
        },
        buttonsStyling: false
      });

      swalWithBootstrapButtons
        .fire({
          title: `Are you sure you want to disburse the loan of &#8358; ${this.loanData.approved_loan_amount} to ${this.loanData.user.first_name} ${this.loanData.user.last_name} with <span class='text-uppercase'>${this.disburse.payment_method}</span>`,
          text: "You won't be able to revert",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, continue!",
          cancelButtonText: "No Cancel",
          reverseButtons: true
        })
        .then(result => {
          if (result.isConfirmed) {
            this.disburseFunction();
            this.isDisburseModalVisible = true;
          } else if (result.dismiss == Swal.DismissReason.cancel) {
            // swalWithBootstrapButtons.fire(
            //   "Cancelled",
            //   "Your transaction hasn't change",
            //   "error"
            // );
            Swal.fire({
              timer: 3000,
              icon: "error",
              title: "Cancelled",
              text: "Loan Disbursement Cancelled",
              showConfirmButton: false,
              showCloseButton: false
            });
            this.isDisburseModalVisible = true;
          }
        });
    },
    async disburseFunction() {
      this.formLoading = true;
      try {
        const res = await ApiService.post("loan/instant/disburse", {
          ...this.disburse,
          disbursed_status: "yes",
          instant_reference: this.slug
        });
        this.closeDisburseModal();
        Swal.fire({
          title: "Success",
          text: res.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        setTimeout(() => this.getLoan(), 4000);
        this.formLoading = false;
      } catch (error) {
        this.closeDisburseModal();
        console.log(error.response);
        this.formLoading = false;

        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
      }
    },
    async repayAction() {
      try {
        this.formLoading = true;
        const res = await ApiService.post("loan/instant/repay", {
          instant_reference: this.slug,
          payment_method: this.payment_method,
          amount: this.amount,
          card_id: this.card_id
        });
        this.closeRepayModal();
        Swal.fire({
          title: "Success",
          text: res.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        setTimeout(() => this.getLoan(), 4000);
        this.formLoading = false;
      } catch (error) {
        this.closeRepayModal();
        console.log(error.response);
        this.formLoading = false;

        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
      }
    },
    async reviewLoan() {
      this.formLoading = true;
      try {
        const res = await ApiService.post("loan/instant/review", {
          instant_reference: this.slug,
          review_status: this.r_status,
          review_status_reason: this.r_reason,
          review_status_details: this.r_details
        });
        this.closeReviewModal();
        Swal.fire({
          title: "Success",
          text: res.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        setTimeout(() => this.getLoan(), 4000);
        this.formLoading = false;
      } catch (error) {
        this.closeReviewModal();
        console.log(error);
        this.formLoading = false;

        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
      }
    },
    closeReviewModal() {
      this.isReviewModalVisible = !this.isReviewModalVisible;
      this.r_status = "";
      this.r_details = "";
      this.r_reason = "";
    },
    openImageModal(param) {
      this.images = [];
      this.$viewerApi({
        images: [param]
      });
      this.images.push(param);
      console.log(this.images);
      // this.photoLoading = true;
      console.log(param);
      setTimeout(() => this.setImage(param), 4000);
    },
    setImage(param) {
      this.imageModalQuery = param;
      // this.photoLoading = false;
      // this.showImageVisible = true;
    },
    async getLoan() {
      try {
        this.pageLoading = true;
        const res = await ApiService.get(`loan/instant/view/${this.slug}`);
        console.log(res);
        this.loanData = res.data.data;
        if (this.can("loan-contacts")) {
          this.getContacts(this.loanData.user_id);
        }
        this.getLoanCard(this.loanData.user_id);
        if (this.can("view-customer")) {
          this.getBVNImage(this.loanData.user_id);
        }
        this.getLoanHistory(this.loanData.user_id);
        if (this.can("credit-report")) {
          this.getCreditReportByUser();
        }
        this.statusQuery = this.loanData.loan_status;
        this.pageLoading = false;
      } catch (error) {
        this.pageLoading = false;
        console.log(error);
      }
    },
    async retriggerIncomeSweep(type) {
      try {
        this.incomeSweepLoading = true;
        const res = await ApiService.post("loan/instant/retrigger-income-sweep", {
          instant_reference: this.slug,
          type
        });
        Swal.fire({
          title: "Success",
          text: res.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        setTimeout(() => this.getLoan(), 4000);
        this.incomeSweepLoading = false;
      } catch (error) {
        this.incomeSweepLoading = false;
        let _error = error.response && error.response.data;
        if (_error) {
          ErrorService.displayErrorAlert(_error);
        }
      }
    },
    openRepayModal() {
      this.isRepayVisible = true;
    },
    closeRepayModal() {
      this.isRepayVisible = false;
    },
    async getBVNImage(id) {
      try {
        const response = await ApiService.get(`customer/get-bvn-image/${id}`);
        this.bvn_image = response.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getLoanCard(id) {
      try {
        const res = await ApiService.get(`loan/instant/cards/${id}`);
        this.loanCards = res.data.data;
      } catch (error) {
        console.log(error.response);
      }
    },

    async getContacts(id) {
      try {
        const res = await ApiService.get(`loan/instant/contacts/${id}`);
        this.contacts = res.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getLoanHistory(id) {
      try {
        const response = await ApiService.get(`loan/instant/all?user_id=${id}&bypass=yes`);
        console.log(response);
        this.histories = response.data.data.data;
      } catch (error) {
        console.log(error.response);
      } finally {
        console.log("Ok");
      }
    },
    async getCreditReportByUser() {
      try {
        const response = await ApiService.get(`loan/instant/get_credit_report_by_user/${this.loanData.user_id}`);
        console.log('credit_rep');
        console.log(response);
        this.credit_report = response.data.data
      } catch (error) {
        console.log(error.response);
      } finally {
        console.log("Ok");
      }
    },
    async pullCreditReportByUser() {
      try {
        this.formLoading = true;
        const response = await ApiService.post(`loan/instant/pull_credit_report`, {
          user_id: this.loanData.user_id
        });
        console.log('credit_rep');
        console.log(response);
        this.credit_report = response.data.data
        this.formLoading = false;
      } catch (error) {
        console.log(error.response);
        this.formLoading = false;
      } finally {
        console.log("Ok");
      }
    },
    openDisburseModal() {
      this.isDisburseModalVisible = !this.isDisburseModalVisible;
    },
    closeDisburseModal() {
      this.disburse.payment_method = "";
      this.disburse.disbursed_status = "";
      this.isDisburseModalVisible = !this.isDisburseModalVisible;
    },
    upadateLoanStatusAction() {
      this.showUpdateModal = false;
      Swal.fire({
        title: `Are you sure you want to perform this action`,
        showCancelButton: true,
        confirmButtonText: `Yes, ${this.statusQuery} it!`,
        cancelButtonText: "No, cancel!",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        reverseButtons: true
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await ApiService.post(
              `loan/instant/update_loan_status`,
              {
                status: this.statusQuery,
                instant_reference: this.loanData.instant_reference
              }
            );
            this.getLoan();
            Swal.fire("Action Successful!", "", response.data.message);
          } catch (error) {
            console.log(error.response);
            let _error = error.response.data;
            ErrorService.displayErrorAlert(_error);
          }
        } else {
          Swal.fire("Action Cancelled!", "", "info");
        }
      });
    },
    async getContactAnalysis() {
      try {
        this.contactAnalysisLoading = true;
        const response = await ApiService.get(`loan/instant/contact_analysis/${this.loanData.id}`);
        console.log(response);
        this.contactAnalysisData = response.data.data
        this.contactAnalysisLoading = false;
      } catch (error) {
        this.contactAnalysisLoading = false;
        console.log(error.response);
      } finally {
        console.log("Ok");
      }
    },
    async callContact(phone) {
      this.pageLoading = true;
      this.loader_message = "Please wait while we call the contact";
      try {
        const response = await ApiService.post(`loan/instant/send_voice_message`, {
          phone_number : phone,
          instant_reference : this.loanData.instant_reference
        });
        console.log(response);
        this.pageLoading = false;
        Swal.fire({
          title: "Success",
          text: response.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
      } catch (error) {
        this.pageLoading = false;
        console.log(error.response);
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
      }

    }
  },
  mounted() {
    this.getLoan();
  }
};
</script>

<style scoped></style>
